import { RootState } from "../../store";

export const selectTrainee = (state: RootState) => state.trainee;